import React, { Component } from 'react';
import './Comments.css';
import moment from 'moment';
import Avatar from 'react-avatar';

// const imagePlaceholder = (
//   <svg
//     version="1.1"
//     xmlns="http://www.w3.org/2000/svg"
//     xmlnsXlink="http://www.w3.org/1999/xlink"
//     width="128"
//     height="128"
//     viewBox="0 0 128 128"
//     xmlSpace="preserve"
//     id="avatar"
//   >
//     <rect
//       id="avatar-background"
//       stroke="none"
//       fill="rgb(170, 170, 170)"
//       x="0"
//       y="0"
//       width="128"
//       height="128"
//     />
//     <g id="avatar-icon" transform="translate(59, 73.75)">
//       <circle
//         id="avatar-oval2"
//         stroke="none"
//         fill="rgb(255, 255, 255)"
//         cx="5"
//         cy="-32.75"
//         r="32.5"
//       />
//       <path
//         id="avatar-bezier"
//         stroke="none"
//         fill="rgb(255, 255, 255)"
//         d="M 60.19,54.25 C 57.98,20.49 34.11,-6.08 5,-6.08 -24.11,-6.08 -47.98,20.49 -50.19,54.25 L 60.19,54.25 Z M 60.19,54.25"
//       />
//     </g>
//   </svg>
// );

class Comments extends Component {
    constructor(props) {
        super(props);

        var newComments = [];

        if (props.formData !== undefined) {
            newComments = [...props.formData, {}];
        } else {
            newComments = [{ body: '' }];
        }

        this.state = {
            message: '',
            comments: newComments
        };
    }

    componentWillReceiveProps(nextProps) {
        var newComments = [];
        if (nextProps.formData !== undefined) {
            newComments = [...nextProps.formData];
            this.setState({
                comments: newComments
            });
        } else {
            newComments = [{ body: '' }];
            this.setState({
                comments: newComments
            });
        }
    }

    messageChangeHandler = event => {
        var newComments = [...this.state.comments];

        newComments[newComments.length - 1] = {
            ...newComments[newComments.length - 1],
            body: event.target.value
        };

        this.props.onChange(newComments);

        this.setState({ message: event.target.value, comments: newComments });
    };

    formatDate = date => {
        moment.locale('es');
        return moment(date).format('LLLL');
    };

    render() {
        const { textareaLabel } = this.props;
        const { comments } = this.state;

        let message = (comments, comment, index) => {
            if (comments.length > index + 1) {
                return (
                    <li key={index}>
                        <div className="sl-comments-avatar">
                            <Avatar
                                name={comment.userId}
                                size="60"
                                round={true}
                            />
                        </div>
                        <div className="sl-comments-info">
                            <h4 className="title">{comment.userName}</h4>
                            <div className="date">
                                {this.formatDate(comment.datetime)}
                            </div>
                            <div className="message">{comment.body}</div>
                        </div>
                    </li>
                );
            }
        };

        return (
            <div>
                <ul className="sl-comments-list">
                    {comments.map((comment, index) =>
                        message(comments, comment, index)
                    )}
                </ul>

                <div className="form-group">
                    <label htmlFor="commentsInput">
                        {textareaLabel ? textareaLabel : 'Mensaje'}
                    </label>
                    <textarea
                        id="commentsInput"
                        className="form-control"
                        rows="3"
                        value={this.state.message}
                        onChange={this.messageChangeHandler}
                        required
                    />
                </div>
            </div>
        );
    }
}

export default Comments;



// WEBPACK FOOTER //
// ./src/lib/Comments/Comments.jsx